import { render, staticRenderFns } from "./RecipeDeclined.vue?vue&type=template&id=16979a44"
import script from "./RecipeDeclined.vue?vue&type=script&lang=js"
export * from "./RecipeDeclined.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports